export function buildMessageSearchText(message) {
	if (!message) return '';
	if (Number(message.type) === 0) return String(message.content || '');
	if (Number(message.type) !== 2) return '';
	try {
		const content = JSON.parse(message.content || '{}');
		return String(content && content.name || '');
	} catch (error) {
		return '';
	}
}
